<mat-card *ngIf="metabolicInfo" style="margin-top: 5px;">
    <mat-card-title style="display: flex; flex-flow: row; justify-content: space-between;align-items:center;">
        <span>Today's Targets</span>
        <button (click)="hide.emit()" mat-raised-button>Hide Targets</button>
    </mat-card-title>
    <mat-card-content >
        <mat-button-toggle-group [value]="genderPref" (change)="setGenderPrefs($event)" name="fontStyle" aria-label="Font Style">
            <mat-button-toggle [value]="MetabolismGender.Male">Male</mat-button-toggle>
            <mat-button-toggle [value]="MetabolismGender.Female">Female</mat-button-toggle>
        </mat-button-toggle-group>
                  
        <div class="meta-rate">
            <span class="meta-title">
                Resting Metabolic Rate
            </span>
            <span class="meta-value male">
                {{ metabolicInfo.basal.toFixed(0) }}
            </span>
        </div>
        <div class="meta-rate">
            <span class="meta-title">
                Caloric Need
            </span>
            <span class="meta-value">
                {{ metabolicInfo.need.toFixed(0) }}
            </span>
        </div>
        <div class="macro-targets">
            <span class="macro-title">
                Macronutrients
            </span>
            <span class="macro-value prot">
                protein: {{ metabolicInfo.proteinTarget.toFixed(2) }}
            </span>
            <span class="macro-value carb">
                carbs: {{ metabolicInfo.carbsTarget.toFixed(2) }}
            </span>
            <span class="macro-value fat">
                fat: {{ metabolicInfo.fatTarget.toFixed(2) }}
            </span>
        </div>
    </mat-card-content>
</mat-card>